import { useApiClient } from '@tonnie/sdk';
import { createTraceIdInterceptor } from '@tonnie/observability';
import { useEffect } from 'react';

export function TraceIdBridge(): null {
  const client = useApiClient();

  useEffect(() => {
    client.addRequestInterceptor(createTraceIdInterceptor());
  }, [client]);

  return null;
}
